import { useEffect, useState } from "react";
import { usePatchAdb } from "../../../../hooks/AdministrateurDeBien";

export const useHabilitationsAdb = (
  idAdb: number,
  parcoursLocataire?: boolean
) => {
  const [parcoursLocataireChecked, setParcoursLocataireChecked] =
    useState<boolean>(parcoursLocataire || false);

  const {
    mutate: patchAdb,
    isLoading: loadingPatchAdb,
    error: errorPatchAdb,
    isSuccess: successPatchAdb,
    reset: resetPatchAdb,
  } = usePatchAdb();

  const handleChangeParcoursLocataire = (value: boolean) => {
    setParcoursLocataireChecked(value);
    patchAdb({
      id: idAdb,
      habilitations: {
        parcoursCandidatLocataire: value,
      },
    });
  };
  useEffect(() => {
    let timer1 = setTimeout(() => resetPatchAdb, 3000);

    return () => {
      clearTimeout(timer1);
    };
  }, [successPatchAdb]);
  return {
    parcoursLocataireChecked,
    loadingPatchAdb,
    errorPatchAdb,
    handleChangeParcoursLocataire,
    successPatchAdb,
    resetPatchAdb,
  };
};
